import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

type AuthFormProps = {
  centered?: boolean;
};

// eslint-disable-next-line import/prefer-default-export
export const AuthForm = styled.form<AuthFormProps>`
  width: 100%;
  max-width: 415px;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 70px;
  height: fit-content;
  position: relative;

  ${({ centered }) =>
    centered
      ? css`
          align-self: center;
        `
      : null}

  a {
    margin: 16px 0 32px 0;
  }

  span {
    margin-top: 32px;
    font-size: ${fontSize(14)};
  }

  @media only screen and ${breakpoint.lg} {
    max-width: 320px;
  }

  @media only screen and ${breakpoint.md} {
    max-width: unset;
    width: 100%;
    max-width: 500px;
    padding: 0 15px;
  }
`;
